export default "__VITE_ASSET__KKmFMp5M__"